import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/BottleService.css";

const BottleService = () => {
    useEffect(() => {
        const sections = document.querySelectorAll(".animated-section");
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("visible");
                    }
                });
            },
            { threshold: 0.2 }
        );
        sections.forEach((section) => observer.observe(section));
    }, []);

    return (
        <div className="bottle-service-page">
            <div className="bottle-hero">
                <h1 className="hero-title">VIP Bottle Service</h1>
                <p className="hero-subtitle">The Ultimate Nightlife Experience</p>
                <p className="hero-description">
                    Indulge in luxury. Unmatched service, exclusive seating, and the finest spirits await.
                </p>
            </div>

            <div className="animated-section offer-section">
                <h2 className="section-title offer-title">What We Offer</h2>
                <div className="luxury-offer-container">
                    <div className="luxury-content">
                        <p className="luxury-description">
                            At <span className="highlight">Sol Cafe & Lounge</span>, we offer more than just a night out — we create experiences. Enjoy <strong>private VIP seating</strong>, <strong>dedicated bottle service</strong>, and a curated selection of the <strong>finest spirits</strong>, all in an exclusive and vibrant atmosphere.
                        </p>
                    </div>
                </div>
            </div>



            {/* Premium Bottle Packages */}
            <div className="packages-section animated-container">
                <h2 className="section-title premium-title">Premium Bottle Packages</h2>
                <div className="packages">
                    <div className="package-card champagne">
                        <h3>Classic Champagne Experience</h3>
                        <p className="package-price">$500</p>
                    </div>
                    <div className="package-card whiskey">
                        <h3>Luxury Whiskey Selection</h3>
                        <p className="package-price">$750</p>
                    </div>
                    <div className="package-card vodka">
                        <h3>Signature Vodka Collection</h3>
                        <p className="package-price">$600</p>
                    </div>
                    <div className="package-card magnum">
                        <h3>VIP Magnum Experience</h3>
                        <p className="package-price">$1,200</p>
                    </div>
                </div>
            </div>

            {/* Full-Width Image Section */}
            <div className="full-image-section">
                <div className="image-overlay">
                    {/*<h2 className="overlay-text">Experience the Pinnacle of Nightlife</h2>*/}
                </div>
            </div>



            <div className="cta-section">
                <h2>Reserve Your Experience Today</h2>
                <Link to="/reserve" className="cta-button">
                    Book Now
                </Link>
            </div>
        </div>
    );
};

export default BottleService;
